import { useTheme, Avatar } from "@mui/material";
import React from "react";
import md5 from "md5";
import runtime from "config/runtime";

const ProfileAvatar = (props) => {
  const theme = useTheme();

  let avatarUrl;

  // Check for custom avatar first (handle both Avatar and avatar casing)
  const userAvatar = props.user.Avatar || props.user.avatar;
  if (userAvatar) {
    const ATTACHMENT_URL = runtime.attachmentUrl;
    avatarUrl = `${ATTACHMENT_URL}${userAvatar}`;
  } else {
    // Gravatar fallback
    const baseURL = "https://www.gravatar.com/avatar/";
    const newEmail = props.user.email.toLocaleLowerCase().trim();
    const encodedVal = md5(newEmail);
    avatarUrl = baseURL + encodedVal + "?s=200&d=mp";
  }

  const size = parseInt(props.size);

  return (
    <Avatar
      alt={props.user.firstName + " " + props.user.lastName}
      src={avatarUrl}
      sx={{
        width: size,
        height: size,
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: theme.palette.primary.main,
      }}
    />
  );
};

export default ProfileAvatar;